import { AppContent } from 'content/AppContent';

const technicalErrorPage: AppContent['technicalErrorPage'] = {
  technicalErrorPageContent: [
    {
      serviceName: 'Online for Business',
      header: 'Sorry, something’s gone wrong',
      errorNotificationHeading: 'This is due to an issue on our side',
      errorNotificationInfo: `It shouldn’t take long to fix, so please try again later.`,
      technicalErrorPageContents: {
        content1: 'Please call us on',
        contactNo: '0345 072 5555',
        dot: '.',
        content2: `We're open Mon-Fri 7am-8pm, Sat 9am-2pm. If you're outside the UK call +44 1733 347 338`,
        content3: `You can call us using Relay UK if you have a hearing or speech impairment. There's more information on the`,
        callUsLabel: 'Relay UK help pages',
        callUsHelpLink: 'https://www.relayuk.bt.com',
        signVideoLabel: 'Sign Video services',
        signVideoLink: 'https://www.lloydsbank.com/contact-us/sign-video.html',
        content4: `are also available if you’re Deaf and use British Sign Language.`,
      },
      backToWebsiteButton: 'Back to lloydsbank.com',
      backToWebsiteLink:
        'https://www.lloydsbank.com/business/banking-online/online-for-business/register-for-online-for-business.html',
    },
  ],
};

export default technicalErrorPage;
